import { render, staticRenderFns } from "./rightsDialog.vue?vue&type=template&id=b73c3f6a&"
import script from "./rightsDialog.vue?vue&type=script&lang=js&"
export * from "./rightsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports